import { useCallback } from 'react';
import { usePermissionsContext } from '../context/PermissionContext';

/**
 * Hook لإدارة صلاحيات WooCommerce
 * يوفر طرقاً للتحقق من صلاحيات صفحات WooCommerce
 */
export const useWooCommercePermissions = () => {
  const { hasPermission } = usePermissionsContext();

  /**
   * التحقق من صلاحية صفحة طلبات WooCommerce
   * @param action الإجراء المطلوب التحقق منه
   * @returns {boolean} صحيح إذا كان المستخدم يملك الصلاحية
   */
  const hasWooCommerceOrdersPermission = useCallback(
    (action: string): boolean => {
      return hasPermission('invoices', 'woocommerce-orders', action);
    },
    [hasPermission]
  );

  /**
   * التحقق من صلاحية صفحة إعدادات WooCommerce
   * @param action الإجراء المطلوب التحقق منه
   * @returns {boolean} صحيح إذا كان المستخدم يملك الصلاحية
   */
  const hasWooCommerceSettingsPermission = useCallback(
    (action: string): boolean => {
      return hasPermission('invoices', 'woocommerce-settings', action);
    },
    [hasPermission]
  );

  return {
    hasWooCommerceOrdersPermission,
    hasWooCommerceSettingsPermission
  };
};
